import { create } from "zustand";

const UseSelectedTarifsID = create( (set) => ({
    value: 0,	
  setSelectedTarifID: (val) => set({value: val}),
}));

export default UseSelectedTarifsID;